<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        color="success"
        block
        v-on="on"
      >
        Create Work Session Type
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Work Session Type"
      text="Create Work Session Type"
      class="mb-0"
    > 
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                v-validate="'required'"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                label="Name"
              />
            </v-col>
            <v-col class="py-0">
              <v-text-field
                label="Monday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="mondayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mondayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="mondayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="mondayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="mondayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mondayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="mondayEndTime"
                  :landscape="true"
                  width="190"
                  :min="mondayStartTime"
                  scrollable
                  @click:minute="mondayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="mondayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mondayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="mondayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="mondayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="mondayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="mondayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="mondayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  :min="mondayLunchRangeFromTime"
                  scrollable
                  @click:minute="mondayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Tuesday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="tuesdayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="tuesdayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="tuesdayStartTime"
                  :landscape="true"
                  width="190"
                
                  scrollable
                  @click:minute="tuesdayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="tuesdayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="tuesdayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="tuesdayEndTime"
                  :landscape="true"
                  width="190"
                  :min="tuesdayStartTime"
                  scrollable
                  @click:minute="tuesdayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="tuesdayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="tuesdayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="tuesdayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="tuesdayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="tuesdayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="tuesdayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="tuesdayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  :min="tuesdayLunchRangeFromTime"
                  scrollable
                  @click:minute="tuesdayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Wednesday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="wednesdayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="wednesdayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="wednesdayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="wednesdayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="wednesdayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="wednesdayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="wednesdayEndTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="wednesdayStartTime"
                  @click:minute="wednesdayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="wednesdayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="wednesdayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="wednesdayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="wednesdayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="wednesdayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="wednesdayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="wednesdayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="wednesdayLunchRangeFromTime"
                  @click:minute="wednesdayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Thursday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="thursdayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="thursdayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="thursdayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="thursdayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="thursdayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="thursdayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="thursdayEndTime"
                  :landscape="true"
                  width="190"
                  :min="thursdayStartTime"
                  scrollable
                  @click:minute="thursdayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="thursdayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="thursdayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="thursdayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="thursdayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="thursdayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="thursdayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="thursdayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="thursdayLunchRangeFromTime"
                  @click:minute="thursdayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
          
          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Friday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="fridayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fridayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="fridayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="fridayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="fridayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fridayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="fridayEndTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="fridayStartTime"
                  @click:minute="fridayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="fridayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fridayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="fridayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="fridayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="fridayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fridayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="fridayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="fridayLunchRangeFromTime"
                  @click:minute="fridayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Saturday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="saturdayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="saturdayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="saturdayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="saturdayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="saturdayEndTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  :min="saturdayStartTime"
                  @click:minute="saturdayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="saturdayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="saturdayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="saturdayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="saturdayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="saturdayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="saturdayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  :min="saturdayLunchRangeFromTime"
                  scrollable
                  @click:minute="saturdayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="py-0">
              <v-text-field
                label="Sunday"
                disabled
              />
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="sundayStartTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayStartTimeDisplay"
                    :rules="rules"
                    label="From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="sundayStartTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="sundayStartTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="sundayEndTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayEndTimeDisplay"
                    :rules="rules"
                    label="To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="sundayEndTime"
                  :landscape="true"
                  width="190"
                  :min="sundayStartTime"
                  scrollable
                  @click:minute="sundayEndTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="sundayLunchRangeFromTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayLunchRangeFromTimeDisplay"
                    :rules="rules"
                    label="Lunch Range From"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="sundayLunchRangeFromTime"
                  :landscape="true"
                  width="190"
                  scrollable
                  @click:minute="sundayLunchRangeFromTimeMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col class="py-0">
              <v-menu
                v-model="sundayLunchRangeToTimeMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="sundayLunchRangeToTimeDisplay"
                    :rules="rules"
                    label="Lunch Range To"
                    prepend-icon="mdi-clock"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  ref="picker"
                  v-model="sundayLunchRangeToTime"
                  :landscape="true"
                  width="190"
                  :min="sundayLunchRangeFromTime"
                  scrollable
                  @click:minute="sundayLunchRangeToTimeMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="success"          
          @click="submitForm"
        >
          Create
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    inject: ['$validator'],
    data () {
      return {
        name: null,
        dialog: false,        
        progressing: false,    
        rules: [
          value => !!value || 'Required.',
        ],
        mondayStartTimeMenu: false,
        mondayStartTime: null,
        mondayEndTimeMenu: false,
        mondayEndTime: null,
        mondayLunchRangeFromTimeMenu: false,
        mondayLunchRangeFromTime: null,
        mondayLunchRangeToTimeMenu: false,
        mondayLunchRangeToTime: null,
        tuesdayStartTimeMenu: false,
        tuesdayStartTime: null,
        tuesdayEndTimeMenu: false,
        tuesdayEndTime: null,
        tuesdayLunchRangeFromTimeMenu: false,
        tuesdayLunchRangeFromTime: null,
        tuesdayLunchRangeToTimeMenu: false,
        tuesdayLunchRangeToTime: null,
        wednesdayStartTimeMenu: false,
        wednesdayStartTime: null,
        wednesdayEndTimeMenu: false,
        wednesdayEndTime: null,
        wednesdayLunchRangeFromTimeMenu: false,
        wednesdayLunchRangeFromTime: null,
        wednesdayLunchRangeToTimeMenu: false,
        wednesdayLunchRangeToTime: null,
        thursdayStartTimeMenu: false,
        thursdayStartTime: null,
        thursdayEndTimeMenu: false,
        thursdayEndTime: null,
        thursdayLunchRangeFromTimeMenu: false,
        thursdayLunchRangeFromTime: null,
        thursdayLunchRangeToTimeMenu: false,
        thursdayLunchRangeToTime: null,
        fridayStartTimeMenu: false,
        fridayStartTime: null,
        fridayEndTimeMenu: false,
        fridayEndTime: null,
        fridayLunchRangeFromTimeMenu: false,
        fridayLunchRangeFromTime: null,
        fridayLunchRangeToTimeMenu: false,
        fridayLunchRangeToTime: null,
        saturdayStartTimeMenu: false,
        saturdayStartTime: null,
        saturdayEndTimeMenu: false,
        saturdayEndTime: null,
        saturdayLunchRangeFromTimeMenu: false,
        saturdayLunchRangeFromTime: null,
        saturdayLunchRangeToTimeMenu: false,
        saturdayLunchRangeToTime: null,
        sundayStartTimeMenu: false,
        sundayStartTime: null,
        sundayEndTimeMenu: false,
        sundayEndTime: null, 
        sundayLunchRangeFromTimeMenu: false,
        sundayLunchRangeFromTime: null,
        sundayLunchRangeToTimeMenu: false,
        sundayLunchRangeToTime: null,
      }
    },
    computed: {
      mondayStartTimeDisplay () {
        return this.mondayStartTime ? this.formatTime(this.mondayStartTime) : ''
      },
      mondayEndTimeDisplay () {
        return this.mondayEndTime ? this.formatTime(this.mondayEndTime) : ''
      },
      mondayLunchRangeFromTimeDisplay () {
        return this.mondayLunchRangeFromTime ? this.formatTime(this.mondayLunchRangeFromTime) : ''
      },
      mondayLunchRangeToTimeDisplay () {
        return this.mondayLunchRangeToTime ? this.formatTime(this.mondayLunchRangeToTime) : ''
      },
      tuesdayStartTimeDisplay () {
        return this.tuesdayStartTime ? this.formatTime(this.tuesdayStartTime) : ''
      },
      tuesdayEndTimeDisplay () {
        return this.tuesdayEndTime ? this.formatTime(this.tuesdayEndTime) : ''
      },
      tuesdayLunchRangeFromTimeDisplay () {
        return this.tuesdayLunchRangeFromTime ? this.formatTime(this.tuesdayLunchRangeFromTime) : ''
      },
      tuesdayLunchRangeToTimeDisplay () {
        return this.tuesdayLunchRangeToTime ? this.formatTime(this.tuesdayLunchRangeToTime) : ''
      },
      wednesdayStartTimeDisplay () {
        return this.wednesdayStartTime ? this.formatTime(this.wednesdayStartTime) : ''
      },
      wednesdayEndTimeDisplay () {
        return this.wednesdayEndTime ? this.formatTime(this.wednesdayEndTime) : ''
      },
      wednesdayLunchRangeFromTimeDisplay () {
        return this.wednesdayLunchRangeFromTime ? this.formatTime(this.wednesdayLunchRangeFromTime) : ''
      },
      wednesdayLunchRangeToTimeDisplay () {
        return this.wednesdayLunchRangeToTime ? this.formatTime(this.wednesdayLunchRangeToTime) : ''
      },
      thursdayStartTimeDisplay () {
        return this.thursdayStartTime ? this.formatTime(this.thursdayStartTime) : ''
      },
      thursdayEndTimeDisplay () {
        return this.thursdayEndTime ? this.formatTime(this.thursdayEndTime) : ''
      },
      thursdayLunchRangeFromTimeDisplay () {
        return this.thursdayLunchRangeFromTime ? this.formatTime(this.thursdayLunchRangeFromTime) : ''
      },
      thursdayLunchRangeToTimeDisplay () {
        return this.thursdayLunchRangeToTime ? this.formatTime(this.thursdayLunchRangeToTime) : ''
      },
      fridayStartTimeDisplay () {
        return this.fridayStartTime ? this.formatTime(this.fridayStartTime) : ''
      },
      fridayEndTimeDisplay () {
        return this.fridayEndTime ? this.formatTime(this.fridayEndTime) : ''
      },
      fridayLunchRangeFromTimeDisplay () {
        return this.fridayLunchRangeFromTime ? this.formatTime(this.fridayLunchRangeFromTime) : ''
      },
      fridayLunchRangeToTimeDisplay () {
        return this.fridayLunchRangeToTime ? this.formatTime(this.fridayLunchRangeToTime) : ''
      },
      saturdayStartTimeDisplay () {
        return this.saturdayStartTime ? this.formatTime(this.saturdayStartTime) : ''
      },
      saturdayEndTimeDisplay () {
        return this.saturdayEndTime ? this.formatTime(this.saturdayEndTime) : ''
      },
      saturdayLunchRangeFromTimeDisplay () {
        return this.saturdayLunchRangeFromTime ? this.formatTime(this.saturdayLunchRangeFromTime) : ''
      },
      saturdayLunchRangeToTimeDisplay () {
        return this.saturdayLunchRangeToTime ? this.formatTime(this.saturdayLunchRangeToTime) : ''
      },
      sundayStartTimeDisplay () {
        return this.sundayStartTime ? this.formatTime(this.sundayStartTime) : ''
      },
      sundayEndTimeDisplay () {
        return this.sundayEndTime ? this.formatTime(this.sundayEndTime) : ''
      },
      sundayLunchRangeFromTimeDisplay () {
        return this.sundayLunchRangeFromTime ? this.formatTime(this.sundayLunchRangeFromTime) : ''
      },
      sundayLunchRangeToTimeDisplay () {
        return this.sundayLunchRangeToTime ? this.formatTime(this.sundayLunchRangeToTime) : ''
      },
    },

    watch: {
      dialog (value) {
        if (!value) {
          this.$resetData()
        }
      },
    },

    methods: {
      prepareFormData () {
        return {
          name: this.name,
          details: [
            { day: 1, start_time: this.mondayStartTime, end_time: this.mondayEndTime, lunch_range_from: this.mondayLunchRangeFromTime, lunch_range_to: this.mondayLunchRangeToTime },
            { day: 2, start_time: this.tuesdayStartTime, end_time: this.tuesdayEndTime, lunch_range_from: this.tuesdayLunchRangeFromTime, lunch_range_to: this.tuesdayLunchRangeToTime },
            { day: 3, start_time: this.wednesdayStartTime, end_time: this.wednesdayEndTime, lunch_range_from: this.wednesdayLunchRangeFromTime, lunch_range_to: this.wednesdayLunchRangeToTime },
            { day: 4, start_time: this.thursdayStartTime, end_time: this.thursdayEndTime, lunch_range_from: this.thursdayLunchRangeFromTime, lunch_range_to: this.thursdayLunchRangeToTime },
            { day: 5, start_time: this.fridayStartTime, end_time: this.fridayEndTime, lunch_range_from: this.fridayLunchRangeFromTime, lunch_range_to: this.fridayLunchRangeToTime },
            { day: 6, start_time: this.saturdayStartTime, end_time: this.saturdayEndTime, lunch_range_from: this.saturdayLunchRangeFromTime, lunch_range_to: this.saturdayLunchRangeToTime },
            { day: 7, start_time: this.sundayStartTime, end_time: this.sundayEndTime, lunch_range_from: this.sundayLunchRangeFromTime, lunch_range_to: this.sundayLunchRangeToTime },
          ],
        }
      },

      submitForm () {
        this.progressing = true

        this.$api.workSessionTypes().create(this.prepareFormData())
          .then(res => {
            this.$snack({ message: 'Work Sesssion Type created succesfully' })
          })
          .catch(() => {})
          .then(() => {
            this.$emit('created')     
            this.progressing = false
            this.dialog = false
          })
      },   

      formatTime (time) {
        let a = time.split(':') // split it at the colons
        let seconds = (a[0] * 60 * 60) + (a[1] * 60)

        return this.$moment(new Date(1970, 0, 1).setSeconds(seconds)).format('hh:mm A')
      },
    },
  }
</script>
